import { Container as ContainerMaterial } from '@mui/material';
import { Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
    }
});

const Container = (props) => {
    const classes = useStyles();
    return (
        <ContainerMaterial
            {...props}
            maxWidth={false}
            className={classes.paper}
            component={Paper}
        >
            {props.children}
        </ContainerMaterial>
    )
}

export default Container;